import { render, staticRenderFns } from "./platformRight.vue?vue&type=template&id=3a1267a4&scoped=true"
import script from "./platformRight.vue?vue&type=script&lang=js"
export * from "./platformRight.vue?vue&type=script&lang=js"
import style0 from "./platformRight.vue?vue&type=style&index=0&id=3a1267a4&prod&scoped=true&lang=css"
import style1 from "./platformRight.vue?vue&type=style&index=1&id=3a1267a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1267a4",
  null
  
)

export default component.exports